import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=0311c398&scoped=true&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Video.vue?vue&type=style&index=1&id=0311c398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311c398",
  null
  
)

export default component.exports